import { Component, input } from '@angular/core';

@Component({
  selector: 'app-custom-space-for-siblings-column',
  standalone: true,
  imports: [],
  templateUrl: './custom-space-for-siblings-column.component.html',
  styleUrl: './custom-space-for-siblings-column.component.scss'
})
export class CustomSpaceForSiblingsColumnComponent {
  public value = input<boolean>()
  public rowData = input<any>()
  public field = input<string>()
}
